(function(){
  if (window.__vcInit) return;
  window.__vcInit = true;

  var PLAY_SVG = '<span class="vc__play"><svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="22" fill="rgba(0,0,0,0.55)"/><path d="M19 16l14 8-14 8V16z" fill="#fff"/></svg></span>';
  var PLUS_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var CHECK_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 10.5l4 4 8-9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Product cache — {handle: productJson}
  var productCache = {};
  function loadProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {headers: {'Accept':'application/json'}})
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) { if (p) productCache[handle] = p; return p; })
      .catch(function() { return null; });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatPrice(paise) {
    // Shopify Ajax returns price as integer in paise/cents. Divide by 100. INR uses ₹ + Indian grouping.
    var rupees = Math.round(paise / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function isFilenameLike(s) {
    if (!s) return true;
    var t = String(s).trim();
    if (!t) return true;
    if (/\.(mp4|mov|webm|m4v|avi)\b/i.test(t)) return true;
    if (/^[a-f0-9-]{20,}/i.test(t)) return true;
    if (/HD-\d+p|SD-\d+p|Mbps-\d+/.test(t)) return true;
    if (/^[A-Za-z0-9_+\-. ()]{1,4}$/.test(t)) return false;
    return false;
  }
  function cleanCaption(s) { return isFilenameLike(s) ? '' : s; }

  // Determine a fallback product handle from URL (PDP pages)
  function currentPdpHandle() {
    var m = window.location.pathname.match(/^\/products\/([^/?]+)/);
    return m ? m[1] : null;
  }

  function hydrate(mount) {
    if (mount.__hydrated) return;
    mount.__hydrated = true;
    var items;
    try {
      var raw = mount.getAttribute('data-vc-items');
      if (raw) {
        items = JSON.parse(raw);
      } else {
        var urls = JSON.parse(mount.getAttribute('data-vc-urls') || '[]');
        items = urls.map(function(u) { return { url: u, caption: '' }; });
      }
    } catch (e) { items = []; }
    if (!items.length) return;

    var heading = mount.getAttribute('data-vc-heading') || '';
    var defaultProducts = (mount.getAttribute('data-vc-products') || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var pdpFallback = currentPdpHandle();

    // Compute per-item product handles: item.products → mount default (cycled) → PDP fallback
    var itemHandles = items.map(function(it, i) {
      if (Array.isArray(it.products) && it.products.length) return it.products;
      if (defaultProducts.length) return [defaultProducts[i % defaultProducts.length]];
      if (pdpFallback) return [pdpFallback];
      return [];
    });

    var h = '<section class="vc" data-vc>';
    if (heading) h += '<h2 class="vc__heading">' + escapeHtml(heading) + '</h2>';
    h += '<div class="vc__strip">';
    items.forEach(function(it, i) {
      var u = escapeHtml(it.url);
      var cap = escapeHtml(cleanCaption(it.caption || ''));
      h += '<div class="vc__item">';
      h += '<button type="button" class="vc__thumb" data-vc-open="' + i + '" aria-label="Play video ' + (i+1) + '">';
      if (it.poster) {
        // Lightest option: a static poster image (no video bytes at all for the strip).
        h += '<img src="' + escapeHtml(it.poster) + '" alt="" loading="lazy" decoding="async">';
      } else {
        // No poster provided — fall back to a lazily-loaded single video frame.
        h += '<video data-vc-thumb-src="' + u + '#t=0.1" muted playsinline preload="none" tabindex="-1"></video>';
      }
      h += PLAY_SVG;
      h += '</button>';
      if (cap) h += '<div class="vc__caption">' + cap + '</div>';
      h += '<div class="vc__product-slot vc__product-slot--strip" data-vc-strip-slot="' + i + '"></div>';
      h += '</div>';
    });
    h += '</div>';
    h += '<dialog class="vc__modal" data-vc-modal>';
    h += '<button type="button" class="vc__close" data-vc-close aria-label="Close">&times;</button>';
    if (items.length > 1) {
      h += '<button type="button" class="vc__nav vc__nav--prev" data-vc-prev aria-label="Previous video">&lsaquo;</button>';
      h += '<button type="button" class="vc__nav vc__nav--next" data-vc-next aria-label="Next video">&rsaquo;</button>';
    }
    h += '<div class="vc__stage">';
    h += '<video class="vc__player" controls controlsList="nodownload" playsinline data-vc-player></video>';
    h += '<div class="vc__product-slot" data-vc-product-slot></div>';
    h += '</div>';
    h += '<div class="vc__caption vc__caption--modal" data-vc-modal-caption></div>';
    h += '</dialog>';
    h += '</section>';

    mount.innerHTML = h;
    var section = mount.querySelector('[data-vc]');
    section.__urls = items.map(function(it){return it.url;});
    section.__captions = items.map(function(it){return cleanCaption(it.caption || '');});
    section.__productHandles = itemHandles;

    // Populate product cards in each strip item (always visible)
    itemHandles.forEach(function(handles, i) {
      if (!handles || !handles.length) return;
      var slot = section.querySelector('[data-vc-strip-slot="' + i + '"]');
      if (slot) renderProductCard(slot, handles);
    });

    setupActiveTracker(section);
    setupLazyThumbs(section);
  }

  // Thumbnails start with preload="none" (zero bytes). Load a single preview
  // frame only as each thumbnail nears the viewport, so the widget adds no
  // video bytes to initial page load.
  function setupLazyThumbs(section) {
    var vids = section.querySelectorAll('video[data-vc-thumb-src]');
    if (!vids.length) return;
    function load(v) {
      if (v.__vcLoaded) return;
      v.__vcLoaded = true;
      v.setAttribute('preload', 'metadata');
      v.src = v.getAttribute('data-vc-thumb-src');
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        if (en.isIntersecting) { load(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '300px' });
    vids.forEach(function(v) { io.observe(v); });
  }

  function renderProductCard(slot, handles) {
    if (!handles || !handles.length) { slot.innerHTML = ''; slot.__handles = []; return; }
    // Filter dupes, keep order
    handles = handles.filter(function(h,i){ return handles.indexOf(h) === i; });
    slot.__handles = handles;
    slot.__idx = 0;
    renderSingle(slot);
  }
  function renderSingle(slot) {
    var handles = slot.__handles || [];
    if (!handles.length) return;
    var handle = handles[slot.__idx % handles.length];
    slot.classList.add('vc__product-slot--loading');
    slot.innerHTML = '<div class="vc__product vc__product--skeleton"></div>';
    loadProduct(handle).then(function(p) {
      slot.classList.remove('vc__product-slot--loading');
      if (!p) { slot.innerHTML = ''; return; }
      var v = p.variants.find(function(x){return x.available;}) || p.variants[0];
      if (!v) { slot.innerHTML = ''; return; }
      var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^https?:/, '');
      var priceNow = formatPrice(v.price);
      var priceCompare = (v.compare_at_price && v.compare_at_price > v.price) ? formatPrice(v.compare_at_price) : '';
      var multiHint = handles.length > 1
        ? '<button type="button" class="vc__product-more" data-vc-product-cycle aria-label="Next product">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 9l4-4 4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>'
        : '';
      slot.innerHTML =
        '<a class="vc__product" href="/products/' + encodeURIComponent(p.handle) + '">' +
          '<img class="vc__product-img" src="' + escapeHtml(img) + '" alt="" loading="lazy">' +
          '<div class="vc__product-info">' +
            '<div class="vc__product-title">' + escapeHtml(p.title) + '</div>' +
            '<div class="vc__product-price">' +
              (priceCompare ? '<span class="vc__price-old">' + priceCompare + '</span> ' : '') +
              '<span class="vc__price-now">' + priceNow + '</span>' +
            '</div>' +
          '</div>' +
          multiHint +
          '<button type="button" class="vc__product-add" data-vc-add="' + v.id + '" aria-label="Add ' + escapeHtml(p.title) + ' to cart">' + PLUS_SVG + '</button>' +
        '</a>';
    });
  }

  function openThemeCartDrawer() {
    // Minimog theme: <m-cart-drawer> custom element with onCartDrawerUpdate() + open().
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer) {
      // Try theme's own high-level API first
      try {
        if (window.MinimogTheme && window.MinimogTheme.Cart) {
          var C = window.MinimogTheme.Cart;
          Promise.resolve(C.refreshCart && C.refreshCart())
            .then(function() { return C.renderNewCart && C.renderNewCart(); })
            .then(function() { C.openCartDrawer && C.openCartDrawer(); });
          return true;
        }
      } catch (e) {}
      // Fallback: drawer element's own methods
      try {
        if (typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
      } catch (e) {}
      try {
        if (typeof drawer.open === 'function') { drawer.open(); return true; }
      } catch (e) {}
      drawer.classList.add('m-cart-drawer--active');
      return true;
    }
    // Last resort: click the header cart icon (Minimog binds click to open drawer)
    var iconBubble = document.querySelector('.m-cart-icon-bubble, #m-cart-icon-bubble, a[href="/cart"]');
    if (iconBubble) { iconBubble.click(); return true; }
    return false;
  }

  function addToCart(button, variantId) {
    if (button.__busy) return;
    button.__busy = true;
    var originalHtml = button.innerHTML;
    button.classList.add('vc__product-add--busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(variantId,10), quantity: 1}]})
    }).then(function(r) {
      if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'add failed'); });
      return r.json();
    }).then(function() {
      button.innerHTML = CHECK_SVG;
      button.classList.remove('vc__product-add--busy');
      button.classList.add('vc__product-add--done');
      // Update cart count in header
      fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('[data-cart-count], .cart-count, .mini-cart__count, .m-header__cart-count').forEach(function(el){
          el.textContent = c.item_count;
          el.classList.add('has-items');
        });
      });
      // Close the video modal first so drawer is fully visible
      var openModal = document.querySelector('.vc__modal[open]');
      if (openModal) {
        var carousel = openModal.closest('[data-vc]');
        if (carousel) close(carousel);
      }
      // Open the theme's cart drawer with fresh content
      var opened = openThemeCartDrawer();
      if (!opened) toast('Added to cart');  // fallback if no drawer
      setTimeout(function() {
        button.innerHTML = originalHtml;
        button.classList.remove('vc__product-add--done');
        button.__busy = false;
      }, 1800);
    }).catch(function(err) {
      button.innerHTML = originalHtml;
      button.classList.remove('vc__product-add--busy');
      button.__busy = false;
      toast(err.message || 'Could not add to cart');
    });
  }

  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vc__toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('vc__toast--show');
    clearTimeout(toastEl.__t);
    toastEl.__t = setTimeout(function() { toastEl.classList.remove('vc__toast--show'); }, 2200);
  }

  function setupActiveTracker(section) {
    var strip = section.querySelector('.vc__strip');
    var items = section.querySelectorAll('.vc__item');
    if (!strip || items.length < 2) return;

    function update() {
      var stripRect = strip.getBoundingClientRect();
      var stripCenter = stripRect.left + stripRect.width / 2;
      var best = null, bestDist = Infinity;
      items.forEach(function(el) {
        var r = el.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - stripCenter);
        if (d < bestDist) { bestDist = d; best = el; }
      });
      items.forEach(function(el) { el.classList.toggle('vc__item--active', el === best); });
    }

    var rafId = null;
    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function() { rafId = null; update(); });
    }
    strip.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    requestAnimationFrame(function() {
      var mid = items[Math.floor(items.length / 2)];
      if (mid) {
        var stripRect = strip.getBoundingClientRect();
        var midRect = mid.getBoundingClientRect();
        strip.scrollLeft += (midRect.left + midRect.width / 2) - (stripRect.left + stripRect.width / 2);
      }
      update();
    });
  }

  function playSafe(player) { var p = player.play(); if (p && p.catch) p.catch(function(){}); }

  // Shopify hosted video: .../vp/{id}/{id}.<rendition>.mp4 -> adaptive HLS .../vp/{id}/{id}.m3u8
  function deriveHlsUrl(mp4) {
    var m = String(mp4).match(/^(.*)\/([a-f0-9]{20,})\.[^/]+\.mp4(?:[?#].*)?$/i);
    return m ? m[1] + '/' + m[2] + '.m3u8' : null;
  }

  // Lazy-load hls.js only when a browser without native HLS actually plays a video.
  var hlsLibPromise = null;
  function loadHlsLib() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (hlsLibPromise) return hlsLibPromise;
    hlsLibPromise = new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.13/dist/hls.min.js';
      s.async = true;
      s.onload = function() { resolve(window.Hls); };
      s.onerror = function() { reject(new Error('hls.js load failed')); };
      document.head.appendChild(s);
    });
    return hlsLibPromise;
  }

  function teardownHls(carousel) {
    if (carousel.__hls) { try { carousel.__hls.destroy(); } catch (e) {} carousel.__hls = null; }
  }

  // Prefer adaptive HLS (only streams the segments watched); fall back to progressive MP4.
  function setPlayerSource(carousel, player, mp4Url) {
    teardownHls(carousel);
    var hls = deriveHlsUrl(mp4Url);
    // Native HLS (Safari / iOS) — no library needed.
    if (hls && player.canPlayType('application/vnd.apple.mpegurl')) {
      player.src = hls;
      playSafe(player);
      return;
    }
    // hls.js for Chrome / Firefox / Android.
    if (hls && window.MediaSource) {
      loadHlsLib().then(function(Hls) {
        if (Hls && Hls.isSupported()) {
          var inst = new Hls({ maxBufferLength: 10 });
          carousel.__hls = inst;
          inst.loadSource(hls);
          inst.attachMedia(player);
          inst.on(Hls.Events.MANIFEST_PARSED, function() { playSafe(player); });
          inst.on(Hls.Events.ERROR, function(evt, data) {
            if (data && data.fatal) { teardownHls(carousel); player.src = mp4Url; playSafe(player); }
          });
        } else { player.src = mp4Url; playSafe(player); }
      }).catch(function() { player.src = mp4Url; playSafe(player); });
      return;
    }
    // Last resort: progressive MP4.
    player.src = mp4Url;
    playSafe(player);
  }

  function open(carousel, i) {
    var modal = carousel.querySelector('[data-vc-modal]');
    var player = modal.querySelector('[data-vc-player]');
    var capEl = modal.querySelector('[data-vc-modal-caption]');
    var slot = modal.querySelector('[data-vc-product-slot]');
    carousel.__i = i;
    setPlayerSource(carousel, player, carousel.__urls[i]);
    if (capEl) capEl.textContent = (carousel.__captions && carousel.__captions[i]) || '';
    if (slot) renderProductCard(slot, (carousel.__productHandles && carousel.__productHandles[i]) || []);
    if (modal.showModal) modal.showModal();
    else modal.setAttribute('open', '');
  }
  function close(carousel) {
    var modal = carousel.querySelector('[data-vc-modal]');
    var player = modal.querySelector('[data-vc-player]');
    teardownHls(carousel);
    player.pause(); player.removeAttribute('src'); player.load();
    if (modal.close) modal.close();
    else modal.removeAttribute('open');
  }
  function step(carousel, dir) {
    var n = carousel.__urls.length;
    carousel.__i = (carousel.__i + dir + n) % n;
    var player = carousel.querySelector('[data-vc-player]');
    var capEl = carousel.querySelector('[data-vc-modal-caption]');
    var slot = carousel.querySelector('[data-vc-product-slot]');
    setPlayerSource(carousel, player, carousel.__urls[carousel.__i]);
    if (capEl) capEl.textContent = (carousel.__captions && carousel.__captions[carousel.__i]) || '';
    if (slot) renderProductCard(slot, (carousel.__productHandles && carousel.__productHandles[carousel.__i]) || []);
  }

  /* On mobile, move the widget's section so it sits directly below the
     "Discreet Delivery" card (.pdp_dd_wrapper) in the product info column.
     Desktop keeps the original template position. Guarded so MutationObserver
     re-scans don't loop or move it twice. */
  function relocateUnderDD(mount) {
    if (mount.__vcMoved) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var dd = document.querySelector('.pdp_dd_wrapper');
    if (!dd) return;
    var node = mount.closest('.shopify-section') || mount;
    if (node.contains(dd)) return; // safety: never move a parent into its child
    dd.insertAdjacentElement('afterend', node);
    mount.__vcMoved = true;
  }

  // Defer hydrate() (which fires the per-item product-JSON fetches) until the
  // mount nears the viewport. For below-the-fold placements (e.g. homepage) this
  // means the widget makes zero network requests until the user scrolls to it.
  function observeHydrate(m) {
    if (m.__hydrated || m.__vcObserving) return;
    if (!('IntersectionObserver' in window)) { hydrate(m); return; }
    m.__vcObserving = true;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        if (en.isIntersecting) { io.unobserve(en.target); hydrate(en.target); }
      });
    }, { rootMargin: '400px' });
    io.observe(m);
  }

  function scan() {
    document.querySelectorAll('.vc-mount[data-vc-items], .vc-mount[data-vc-urls]').forEach(function(m) {
      relocateUnderDD(m);
      observeHydrate(m);
    });
  }

  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('[data-vc-add]');
    if (addBtn) {
      e.preventDefault(); e.stopPropagation();
      addToCart(addBtn, addBtn.getAttribute('data-vc-add'));
      return;
    }
    var cycleBtn = e.target.closest('[data-vc-product-cycle]');
    if (cycleBtn) {
      e.preventDefault(); e.stopPropagation();
      var slot = cycleBtn.closest('[data-vc-product-slot]');
      if (slot) { slot.__idx = ((slot.__idx || 0) + 1); renderSingle(slot); }
      return;
    }
    var b = e.target.closest('[data-vc-open],[data-vc-close],[data-vc-prev],[data-vc-next]');
    if (!b) return;
    var c = b.closest('[data-vc]');
    if (!c) return;
    e.preventDefault();
    if (b.hasAttribute('data-vc-open')) open(c, parseInt(b.getAttribute('data-vc-open'), 10));
    else if (b.hasAttribute('data-vc-close')) close(c);
    else if (b.hasAttribute('data-vc-prev')) step(c, -1);
    else if (b.hasAttribute('data-vc-next')) step(c, 1);
  });

  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-vc-modal]')) close(e.target.closest('[data-vc]'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
  }
})();
